export class StorageEndpoints {
    public static readonly guideNovelties = "guides/%s";
    public static readonly companyFulfillment = "company/%s/fulfilled";
    public static readonly cargoFulfillment = "cargos/%s/fulfilled";
    public static readonly cargoLocationReportEvidences = "cargos/%s/location-report-evidences";
    public static readonly cargoContainerChecklist = "cargos/%s/container-checklist";
    public static readonly cargoVehicleChecklist = "cargos/%s/vehicle-checklist";
}
